import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';

const GetDischargesByTypeResponseDtoSchema = PagePaginationResponseDtoSchema(
  z.object({
    count: z.number(),
    percentage: z.number().nullable(),
    reason: z.string(),
  })
);

export type GetDischargesByTypeRequestDto = PagePaginationRequestDto<{
  facilityId?: string;
  from: string;
  to: string;
}>;
export type GetDischargesByTypeResponseDto = z.infer<
  typeof GetDischargesByTypeResponseDtoSchema
>;

export const getDischargesByType = (
  params: GetDischargesByTypeRequestDto,
  config?: AxiosRequestConfig<GetDischargesByTypeRequestDto>
) => {
  return api
    .get('residents/discharges-by-type', { params, ...config })
    .then(responseContract(GetDischargesByTypeResponseDtoSchema));
};
